<script lang="ts">
  import { t } from './i18n.svelte'

  let { label = t('Getting cozy…'), waiting = true }: { label?: string; waiting?: boolean } =
    $props()
</script>

<div class="sofa-loading" role="status" aria-live="polite" aria-busy={waiting}>
  <svg class:breathing={waiting} viewBox="0 0 200 140" aria-hidden="true">
    <ellipse class="shadow" cx="100" cy="122" rx="67" ry="6" />
    <g class="couch">
      <rect class="back" x="43" y="37" width="114" height="64" rx="23" />
      <path class="seam" d="M100 43v40" />
      <rect class="seat" x="39" y="81" width="122" height="29" rx="13" />
      <rect class="arm" x="29" y="68" width="23" height="42" rx="11" />
      <rect class="arm" x="148" y="68" width="23" height="42" rx="11" />
      <path class="feet" d="M49 111v7m102-7v7" />
      <path class="face" d="M77 64q5 5 10 0m26 0q5 5 10 0m-27 9q4 4 8 0" />
    </g>
    <g class="dream" class:dreaming={waiting}>
      <path d="M149 25h8l-8 9h8m9-25h10l-10 12h10" />
    </g>
  </svg>
  <p>{label}</p>
  {#if waiting}
    <span class="dots" aria-hidden="true"><i></i><i></i><i></i></span>
  {/if}
</div>

<style>
  .sofa-loading {
    flex: 1;
    min-height: 280px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 12px;
    padding: 32px 16px;
    color: var(--text-dim);
  }
  svg {
    width: 180px;
    overflow: visible;
  }
  p {
    margin: 0;
    font-size: 0.95rem;
  }
  .shadow {
    fill: var(--border);
    opacity: 0.5;
  }
  .back {
    fill: var(--accent-dim);
    stroke: var(--accent);
    stroke-width: 2;
  }
  .seat,
  .arm {
    fill: var(--accent);
  }
  .seam {
    stroke: var(--accent);
    opacity: 0.3;
  }
  .face,
  .feet,
  .dream {
    fill: none;
    stroke: var(--text);
    stroke-width: 3;
    stroke-linecap: round;
  }
  .dream {
    stroke: var(--text-faint);
    stroke-width: 2;
  }
  .breathing .couch {
    transform-origin: 100px 110px;
    animation: breathe 2.8s ease-in-out infinite;
  }
  .dreaming {
    animation: dream 2.8s ease-in-out infinite;
  }
  .dots {
    display: flex;
    gap: 6px;
    height: 6px;
  }
  .dots i {
    width: 5px;
    height: 5px;
    border-radius: 50%;
    background: var(--accent);
    animation: pulse 1.4s ease-in-out infinite;
  }
  .dots i:nth-child(2) {
    animation-delay: 0.18s;
  }
  .dots i:nth-child(3) {
    animation-delay: 0.36s;
  }
  @keyframes breathe {
    50% {
      transform: translateY(-2px) scaleY(1.025);
    }
  }
  @keyframes dream {
    50% {
      opacity: 0.45;
      transform: translateY(-4px);
    }
  }
  @keyframes pulse {
    50% {
      opacity: 0.25;
      transform: translateY(-2px);
    }
  }
  @media (prefers-reduced-motion: reduce) {
    .breathing .couch,
    .dreaming,
    .dots i {
      animation: none;
    }
  }
</style>
